/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint no-nested-ternary: 0 */
/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import { v4 as uuid } from 'uuid'
import React, {
  createContext, ReactNode, useContext, useEffect, useState,
} from 'react'
import { makeOrderPad } from '../../main/usecases/order-pads/load-order-pad-factory'
import { makeOrder } from '../../main/usecases/orders/load-order-factory'
import { ServiceCharge } from '../enums/stablishment-tables'
import { calculateServiceCharge, getTableServiceChargeType } from '../helpers/helper-order'
import { useMe } from './me'
import { makeReceipt } from '../../main/usecases/receipts/load-receipts-factory'
import { useModal } from './modal'
import ReceiptModal from '../pages/dashboard/orders/modals/receipt-modal'
import { makeConfigNFC } from '../../main/usecases/config-nfc/load-config-nfc-factory'

interface Product {
  uuid: string
  name: string
  price: string
}

interface OrderItem {
  uuid: string
  status: number
  code: string
  amount: number
  product: Product
  preferenceItems: string
  observation: string
  createdAt: Date | string
  updatedAt: Date | string
}

interface Client {
  uuid: string
  name: string
  email: string | null
  phoneNumber: string | null
}

interface StablishmentTable {
  uuid: string
  id: number
  name: number
  serviceType: number
  chargeType: number
  chargeAmount: number
  hasServiceCharge?: boolean
}

export interface OrderPad {
  uuid: string
  id: number
  name: string | number
  createdAt: string | Date
  updatedAt: string | Date
  status: number
  customerAmount: number
  client: Client
  stablishmentTable: StablishmentTable
  orders: OrderItem[]
}
type IProps = {
  children: ReactNode;
}

type OrderContextProps = {
  order: any;
  orders: any;
  setOrder: (value: any) => void;
  orderPad: OrderPad | null;
  setOrderPad: (value: OrderPad | null) => void;
  orderPadId: string | null;
  setOrderPadId: (value: string | null) => void;
  currentOrderPadCard: any;
  setCurrentOrderPadCard: (value: any) => void;
  amountCustomerIsOpen: boolean;
  setAmountCustomerIsOpen: (value: any) => void;
  orderPadIsOpen: boolean;
  setOrderPadIsOpen: (value: any) => void;
  amountCustomer: number | null;
  setAmountCustomer: (value: any) => void;
  handlePayOrderPad: () => void;
  total: any | null;
  serviceChargeType: any | null;
  serviceCharge: any | null;
  subtotal: any | null;
  lastEvent: any;
  setLastEvent: (value: any) => void;
  isLoadingBilling: boolean;
  onGenerateNonTaxReceipt: (id: number) => void;
  openRecieptModal: (id: number) => void;
}

const OrderContext = createContext({} as OrderContextProps)

const OrderProvider = ({ children }: IProps) => {
  const { me } = useMe()
  const { updateContent, toggleVisibility, updateProps } = useModal()
  const [lastEvent, setLastEvent] = useState<any>(null)
  const [currentOrder, setCurrentOrder] = useState<any>(null)
  const [currentOrderPadId, setCurrentOrderPadId] = useState<string | null>(null)
  const [currentOrderPad, setCurrentOrderPad] = useState<OrderPad | null>(null)
  const [amountCustomerIsOpen, setAmountCustomerIsOpen] = useState(false)
  const [orderPadIsOpen, setOrderPadIsOpen] = useState(false)
  const [amountCustomer, setAmountCustomer] = useState<number | null>(null)
  const [isLoadingBilling, setIsLoadingBilling] = useState(false)
  const [receiptContent, setReceiptContent] = useState<any>({ id: null, content: '' })
  const [currentOrderPadCard, setCurrentOrderPadCard] = useState<any>(null)

  const orders = currentOrderPad?.orders && currentOrderPadCard
    ? currentOrderPadCard.status === 0
      ? currentOrderPad.orders.filter((order) => ![8, 9].includes(order.status))
      : currentOrderPad.orders.filter((order) => order.status === 8)
    : []

  const total = orders.reduce((acc: number, order: OrderItem) => (
    acc + order.amount * (Number(order?.product?.price) ?? 0)
  ), 0) ?? 0

  const serviceType = currentOrderPad?.stablishmentTable?.serviceType ?? 0

  const chargeType = currentOrderPad?.stablishmentTable?.chargeType ?? 0

  const serviceChargeType = getTableServiceChargeType(serviceType, chargeType)

  const serviceCharge = calculateServiceCharge(
    currentOrderPad,
    serviceChargeType,
    amountCustomer,
    total,
  )

  const subtotal = serviceChargeType === ServiceCharge.COVER
    ? (amountCustomer ? total + (serviceCharge || 0) : total)
    : total + (serviceCharge || 0)

  const onGenerateNonTaxReceipt = async (orderPadId: number) => {
    try {
      const orderPadAlreadyExists = receiptContent.id === orderPadId ? 'exists' : 'non-exists'
      const mapper = {
        exists: () => receiptContent.content,
        'non-exists': async () => {
          if (!me) return
          const stablishmentId = me.stablishments[0].id
          const receipt = await makeReceipt(stablishmentId).generateNonTax(orderPadId)

          setReceiptContent({ id: orderPadId, content: receipt.result })
          return receipt.result
        },
      }

      const html = await mapper[orderPadAlreadyExists]()
      // Cria um novo elemento 'iframe' e injeta o HTML nele
      const iframe = document.createElement('iframe')
      document.body.appendChild(iframe)

      iframe.contentDocument!.open()
      iframe.contentDocument!.write(html)
      iframe.contentDocument!.close()

      // Imprime o conteúdo do iframe e remove o iframe após a impressão
      iframe.contentWindow!.onload = () => {
        iframe.contentWindow!.print()
        document.body.removeChild(iframe)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const openRecieptModal = (id: number) => {
    updateContent({
      width: '500px',
      title: 'Comprovante',
      component: () => <ReceiptModal onGenerateNonTax={() => onGenerateNonTaxReceipt(id)} />,
    })
    updateProps({
      styles: { padding: '70px 50px 40px', borderRadius: '16px' },
    })
    toggleVisibility()
  }

  const handlePayOrderPad = async () => {
    if (!me || !currentOrderPad) return
    const stablishmentId = me.stablishments[0].id
    try {
      setIsLoadingBilling(true)
      if (currentOrderPadCard.isUniqueOrderWrapper === false) {
        const paidStatus = 9
        const formattedOrdersWithPaidStatus = orders
          .map((order: any) => ({ id: order.id, status: paidStatus }))
        await makeOrder(currentOrderPad.stablishmentTable.id)
          .patchMultiple(formattedOrdersWithPaidStatus)
      } else {
        const response = await makeConfigNFC(stablishmentId).getByStablishmentId()
        await makeOrderPad(stablishmentId).patchBill(`${currentOrderPad.id}/bill`, { customerAmount: amountCustomer })
        if (response?.configNFC?.id) {
          openRecieptModal(currentOrderPad.id)
        }
        setOrderPadIsOpen(false)
      }
      setCurrentOrderPad(null)
      setCurrentOrderPadCard(null)
      setCurrentOrderPadId(null)
    } catch (error) {
      console.log(error)
    } finally {
      setLastEvent(uuid())
      setIsLoadingBilling(false)
    }
  }

  const handleToggleOrderPadModal = () => {
    if (serviceChargeType === ServiceCharge.COVER && !amountCustomer) {
      setAmountCustomerIsOpen(true)
      return
    }
    setOrderPadIsOpen((state) => !state)
  }

  useEffect(() => {
    if (currentOrder?.orders[0]?.orderPad?.amountCustomer) {
      setAmountCustomer(currentOrder?.orders[0]?.orderPad?.amountCustomer)
    } else {
      setAmountCustomer(0)
    }
  }, [currentOrder])

  useEffect(() => {
    (async () => {
      if (!me || !currentOrderPadId) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeOrderPad(stablishmentId).loadDashboard(currentOrderPadId)
      setCurrentOrderPad(response.orderPad)
    })()
  }, [currentOrderPadId])

  return (
    <OrderContext.Provider
      value={{
        orders,
        currentOrderPadCard,
        setCurrentOrderPadCard,
        order: currentOrder,
        setOrder: setCurrentOrder,
        orderPad: currentOrderPad,
        setOrderPad: setCurrentOrderPad,
        orderPadId: currentOrderPadId,
        setOrderPadId: setCurrentOrderPadId,
        amountCustomerIsOpen,
        setAmountCustomerIsOpen,
        amountCustomer,
        setAmountCustomer,
        orderPadIsOpen,
        setOrderPadIsOpen: handleToggleOrderPadModal,
        total,
        serviceChargeType,
        serviceCharge,
        subtotal,
        handlePayOrderPad,
        lastEvent,
        setLastEvent,
        isLoadingBilling,
        onGenerateNonTaxReceipt,
        openRecieptModal,
      }}
    >
      {children}
    </OrderContext.Provider>
  )
}

export const useOrder = () => {
  const context = useContext(OrderContext)

  if (!context) {
    throw new Error('useOrder must be used within a provider OrderProvider')
  }

  return context
}

export default OrderProvider
